import * as v from "valibot";
import { baseVals, defineValidation } from "../../common/validation.common";

export namespace NetworkGroupValidation {
    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            address: baseVals.ipv4(),
            cidr: baseVals.intRange(16, 32, "CIDR"),
            allowReserved: v.boolean(),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            allowReserved: v.exactOptional(v.boolean()),
        }),
    );
}
